<template>
  <modal :show.sync="modals.classic">
    <h4 slot="header" class="title title-up">{{ $t('app.modules.product_family_prop_group.add.title')  }}</h4>

    <ValidationObserver ref="formAdd" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitNewGroup)">

        <div v-for="lang in group.traducciones">
          <h6>{{ lang.idioma.idioma }}</h6>
          <div class="row">
            <div class="col-sm-12">
              <fg-input
                type="text"
                name="minLength"
                :label="$t('app.modules.product_family_prop.headers.name')"
                v-model="lang.nombreGrupo"
              >
              </fg-input>
            </div>
          </div>
        </div>

        <div
          slot="footer"
          style="margin-top: 10px; padding-top: 20px;border-top: outset;"
          class="text-right"
        >
          <n-button class="pull-left" @click.native="cancelAdd()">{{ $t("app.buttons.cancel") }}</n-button>
          <n-button native-type="submit" type="primary">{{ $t("app.buttons.save") }}</n-button>
        </div>
      </form>
    </ValidationObserver>
  </modal>
</template>

<script>
import { extend } from "vee-validate";
import { min, required } from "vee-validate/dist/rules";
import {mapState} from "vuex";
import Idioma from "@/models/familiaProducto/Idioma";
import GrupoPropiedadFamiliaProductoTraduccion from "@/models/familiaProducto/GrupoPropiedadFamiliaProductoTraduccion";
import {getResponse} from "@/util/utilities";

extend("required", required);
extend("min", min);

export default {
  components: {},
  computed: {
    ...mapState(["availableLangs"]),
  },
  data () {
    return {
      modals: {
        classic: false,
        notice: false,
        mini: false
      },
      group: {
        idGrupoPropiedad: 0,
        traducciones: []
      }
    };
  },
  created() {
    this.group.traducciones = this.availableLangs.map((lang) => new GrupoPropiedadFamiliaProductoTraduccion({
      idGrupoPropFamProdTrad: 0,
      nombreGrupo: "",
      grupoPropiedadFamiliaProducto_idGrupoPropiedad: 0,
      idiomas_idIdioma: lang.idIdioma,
      idioma: new Idioma({
        idIdioma: lang.idIdioma,
        idioma: lang.idioma,
        clave: lang.clave
      })
    }));
  },
  mounted () {
    EventBus.$on("grupoPropiedadFamiliaProductoAdd",  () => {
      this.$swal.fire({
        title: "Por favor espera",
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      this.$swal.close();
      this.modals.classic = true;
    });
  },
  methods: {
    async submitNewGroup() {
      this.$swal.fire({
        title: "Por favor espera",
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

      try
      {
        this.group.traducciones.forEach(t => {
          if(!t.nombreGrupo) throw new Error(this.$t('app.modules.product_family_prop_group.errors.no_name') + ": " + t.idioma.idioma);
        });

        let response = await this.addGroup();

        if(response){
          this.notifyMessage("success", this.$t("app.promps.save_success"));
          EventBus.$emit("update-group");
          this.cancelAdd();
        }
        else this.notifyMessage("danger", this.$t("app.promps.error"));
      }
      catch (e){
        this.notifyMessage('danger', e.message);
      }
      finally
      {
        this.$swal.close();
      }
    },
    async addGroup ()
    {
      let request = await this.$http.post(route("GrupoPropiedadFamiliaProducto/postGrupoPropiedadFamiliaProducto"), this.group);
      return getResponse(request, null);
    },
    cancelAdd() {
      this.group.idGrupoPropiedad = 0;
      this.group.traducciones.forEach(t => t.nombreGrupo = "" );
      this.modals.classic = false;
    }
  }
}
</script>

<style scoped>

</style>
